export function propertyHasTotalSpaceData(property) {
  if (!property) return false;
  return (
    property.propertyFacts?.totalSpace > 0 ||
    property.customPropertyFacts?.primarySpace > 0
  );
}
